function initNewsCollapse() {

    $('.news-more').click(function () {
        let $theButton = $(this);
        if($theButton.hasClass('open')) {
            $theButton.removeClass('open');
            $theButton.text('weiterlesen');
            $theButton.appendTo($theButton.parents('.news-collapse').find('.preview-content'));
        } else {
            $theButton.appendTo($(this).data('target'));
            $theButton.addClass('open');
            $theButton.text('weniger anzeigen');
            let $possibleSlider = $theButton.parents('.news-collapse').find('.slider');
            if($possibleSlider.length > 0) {
                $theButton.parents('.news-collapse').find('.slider').slick('refresh');
            }
        }
    });

    $('.news-gallery .slider').slick(
        {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            dots: false,
            autoplay: false,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    );

    $('.news-gallery').each(function() {
        $().fancybox({
            toolbar: false,
            smallBtn: true,
            selector: '#' + $(this).attr('id') + ' .click-enlarge'
        });
    });

}